const getDefaultModifyCustomerAccountValues = userData => {
  return {
    title: userData?.title || '',
    firstName: userData?.firstName || '',
    lastName: userData?.lastName || '',
    firstAndLastName: `${userData?.firstName} ${userData?.lastName}`,
    language: 'en',
    gender: userData?.gender || '',
    passengerType: userData?.passengerType || 'A',
    city: userData?.city || '',
    county: userData?.county || '',
    postalCode: userData?.postalCode || userData?.postCode || '',
    countryCode: userData?.countryCode || '',
    mobilePhoneNumber: userData?.mobilePhoneNumber || '',
    homePhoneNumber: userData?.homePhoneNumber || '',
    emailAddress: userData?.emailAddress || userData?.email || '',
    acceptsContact: userData?.acceptsContact || false,
    defaultProductCode: userData?.defaultProductCode || false,
    rewardsOptIn: userData?.rewardsOptIn || false,
    promotionIsland: userData?.promotionIsland || false,
    promotionMainland: userData?.promotionMainland || false,
    address: userData?.address || false,
  }
}

export default getDefaultModifyCustomerAccountValues
